import * as React from 'react';
import styles from './index.less';
import img_banner1 from './banner1.png';
import img_banner2Bg from './banner2-bg.png';
import img_banner2Content from './banner2-content.png';
import img_banner3Bg from './banner3-bg.png';
import img_banner4Bg from './banner4-bg.png';
import img_banner4Content from './banner4-content.png';
import img_banner5Bg from './banner5-bg.png';
import img_banner5Content from './banner5-content.png';
import img_banner6Bg from './banner6-bg.png';
import img_yubi from './yubi@2x.png';
import FComponentsLib from '@freelog/components-lib';
import { Modal, Space } from 'antd';
import img_xiaohongshuAvatar from '@/assets/activity/SpringFestival/xiaohongshuAvatar.png';
import img_weibaoAvatar from '@/assets/activity/SpringFestival/weibaoAvatar.png';
import img_QQChatQR from './QQChatQR.jpg';
import img_weixinQR from '@/assets/activity/SpringFestival/weixinQR.jpg';
import FPropaganda from '@/components/FPropaganda';
import FPageFooter from '@/components/FPageFooter';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import { ActivityDetailsPageModelState } from '@/models/activityDetailsPage';
import { connect } from 'dva';
import { ConnectState } from '@/models/connect';
import * as AHooks from 'ahooks';
import FCoverImage from '@/components/FCoverImage';
import img_xiaoshuo from './xiaoshuo@2x.png';
import img_manhua from './manhua@2x.png';
import img_boke from './boke@2x.png';
import FCopyToClipboard from '@/components/FCopyToClipboard';
import dayjs from 'dayjs';

interface Contest202409Props {
  activityDetailsPage: ActivityDetailsPageModelState;
}

function Contest202409({ activityDetailsPage }: Contest202409Props) {
  const [$momentTime, set$momentTime, get$momentTime] = FUtil.Hook.useGetState<dayjs.Dayjs>(dayjs());
  const [$ruleShow, set$ruleShow, get$ruleShow] = FUtil.Hook.useGetState<boolean>(false);
  const [$announceShow, set$announceShow, get$announceShow] =
    FUtil.Hook.useGetState<boolean>(false);

  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);

  // userType
  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    // console.log(data, 'data sdijf;lsdkjfl;ksdjlfksjdlkfjlkjl');
    set$isRegister(data.userType === 1);
  });

  return (
    <>
      <div className={styles.styles}>
        <div className={styles.content}>
          <img src={img_banner1} style={{ width: 1200, display: 'block' }} alt={''} />

          <div className={styles.banner2}>
            <img
              src={img_banner2Bg}
              style={{
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              alt={''}
            />
            <img
              src={img_banner2Content}
              style={{
                position: 'absolute',
                top: 100,
                left: 120,
                height: 565,
                width: 994,
              }}
              alt={''}
            />
          </div>

          <div className={styles.banner3}>
            <img
              src={img_banner3Bg}
              style={{
                width: 1200,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              alt={''}
            />
            <div className={styles.time} style={{ left: 168 }}>
              {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm') || 'YYYY-MM-DD HH:mm'}
            </div>
            <div className={styles.time} style={{ left: 526 }}>
              {activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm') || 'YYYY-MM-DD HH:mm'}
            </div>
            <div className={styles.time} style={{ left: 880 }}>
              {activityDetailsPage.announceTime?.format('YYYY-MM-DD HH:mm') || 'YYYY-MM-DD HH:mm'}
            </div>
          </div>

          <div className={styles.banner4}>
            <img
              src={img_banner4Bg}
              style={{
                width: 1200,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              alt={''}
            />
            <img
              src={img_banner4Content}
              style={{
                width: 957,
                height: 1317,
                position: 'absolute',
                top: 116,
                left: 124,
              }}
              alt={''}
            />

            <div
              style={{
                width: 1200,
                position: 'absolute',
                left: 0,
                bottom: 100,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {activityDetailsPage.announceTime &&
              $momentTime.isAfter(activityDetailsPage.announceTime) ? (
                <div
                  className={styles.button}
                  onClick={() => {
                    set$announceShow(true);
                  }}
                >
                  查看获奖公示
                </div>
              ) : (
                <FComponentsLib.FTitleText
                  text={`获奖结果于 ${
                    activityDetailsPage.announceTime?.format('YYYY-MM-DD HH:mm') ||
                    'YYYY-MM-DD HH:mm'
                  } 进行公示，敬请期待～`}
                  type={'h1'}
                  style={{ fontWeight: 400 }}
                />
              )}
            </div>
          </div>

          <div className={styles.banner5}>
            <img
              src={img_banner5Bg}
              style={{
                width: 1200,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              alt={''}
            />

            <img
              src={img_banner5Content}
              style={{
                width: 812,
                height: 1438,
                position: 'absolute',
                top: 104,
                left: 192,
              }}
              alt={''}
            />

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 328,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                }}
              >
                1. 参与活动需先获取内测资格，已获资格者可直通活动。
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 375,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                }}
              >
                2. 为确保最完整的功体验，推荐使用电脑端访问Freelog网页版。
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 447,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              {$isRegister && <div className={styles.button}>已获资格</div>}
              {!$isRegister && (
                <div
                  className={styles.button}
                  onClick={async () => {
                    const {
                      data,
                    }: {
                      data: {
                        userType: 0 | 1;
                      };
                    } = await FServiceAPI.User.currentUserInfo();

                    if (FUtil.Tool.getUserIDByCookies() === -1) {
                      return;
                    }

                    self.open(
                      FUtil.Format.completeUrlByDomain('console') +
                        FUtil.LinkTo.invitation() +
                        '?type=apply',
                    );
                  }}
                >
                  提交内测申请
                </div>
              )}
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 696,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                  textAlign: 'center',
                  width: 930,
                }}
              >
                1. 发布原创的、符合基础发布标准的、带
                <FCopyToClipboard text={'Freelog合集创作大赛'} title={'点击复制标签'}>
                  <span style={{ color: '#F89971', cursor: 'pointer' }}>“Freelog合集创作大赛”</span>
                </FCopyToClipboard>
                活动标签的任一合集类型资源， 包括连载小说、连载漫画、音乐专辑或连载播客。
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 775,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                }}
              >
                2. 创建小说/漫画/音乐/播客任一主题节点，并将相应的合集资源添加至该节点下。
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 1328,
                display: 'flex',
                justifyContent: 'center',
                gap: 50,
              }}
            >
              <div
                className={styles.button}
                onClick={() => {
                  // set$ruleShow(true);
                  // self.open('https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M23%E3%80%81%E5%8F%91%E8%A1%8C%E5%90%88%E9%9B%86%E8%B5%84%E6%BA%90&w06c513=%2F ');
                  self.open(
                    'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M2%EF%BC%88%E4%B8%89%EF%BC%89%E5%8F%91%E8%A1%8C%E5%90%88%E9%9B%86%E8%B5%84%E6%BA%90&w06c513=%2F%C2%A0',
                  );
                }}
              >
                查看教程
              </div>
              <div
                className={styles.button}
                onClick={() => {
                  self.open(
                    FUtil.Format.completeUrlByDomain('console') +
                      FUtil.LinkTo.resourceCreatorEntry(),
                  );
                }}
              >
                发行合集
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 1576,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                }}
              >
                前往Freelog反馈模块内发帖，提交您“玩转合集”过程中的使用反馈和建议
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 1648,
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <div
                className={styles.button}
                onClick={() => {
                  self.open(
                    'https://forum.freelog.cn/category/3/%E5%90%90%E6%A7%BD%E5%8F%8D%E9%A6%88%E5%8C%BA',
                  );
                }}
              >
                提交反馈
              </div>
            </div>

            <div
              style={{
                position: 'absolute',
                width: 1200,
                top: 1802,
                display: 'flex',
                justifyContent: 'center',
                gap: 40,
              }}
            >
              <div
                style={{
                  fontSize: 22,
                  color: '#222',
                  lineHeight: '32px',
                }}
              >
                关于本次活动更详细的介绍，请参考活动规则
              </div>
              <div
                style={{
                  fontSize: 22,
                  color: '#F89971',
                  lineHeight: '32px',
                  cursor: 'pointer',
                }}
                onClick={() => {
                  set$ruleShow(true);
                }}
              >
                <FComponentsLib.FIcons.FFileSearch style={{ fontSize: 24 }} />
                &nbsp;查看活动参与规则
              </div>
            </div>
          </div>

          <div className={styles.banner6}>
            <img
              src={img_banner6Bg}
              style={{
                width: 1200,
                position: 'absolute',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
              }}
              alt={''}
            />

            <div className={styles.more} style={{ position: 'absolute', width: 1200, top: 200 }}>
              <Space size={10} direction={'vertical'} align={'center'}>
                <div
                  className={styles.moreItem}
                  onClick={() => {
                    self.open('https://www.xiaohongshu.com/user/profile/64c0d3810000000014039a75');
                  }}
                >
                  <div
                    style={{
                      width: 100,
                      height: 100,
                      background: '#FFF',
                      border: '1px solid #E3E3E3',
                      borderRadius: '50%',
                    }}
                  >
                    <img
                      src={img_xiaohongshuAvatar}
                      alt={''}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                  <FComponentsLib.FContentText
                    type={'negative'}
                    text={'Freelog.Official'}
                    style={{ maxWidth: 200 }}
                    singleRow
                  />
                </div>
                <FComponentsLib.FContentText
                  type={'negative'}
                  text={'小红书'}
                  style={{ maxWidth: 200 }}
                  singleRow
                />
              </Space>
              <Space size={10} direction={'vertical'} align={'center'}>
                <div
                  className={styles.moreItem}
                  onClick={() => {
                    self.open('https://weibo.com/freelogofficial');
                  }}
                >
                  <div
                    style={{
                      width: 100,
                      height: 100,
                      background: '#FFF',
                      border: '1px solid #E3E3E3',
                      borderRadius: '50%',
                    }}
                  >
                    <img
                      src={img_weibaoAvatar}
                      alt={''}
                      style={{ width: '100%', height: '100%' }}
                    />
                  </div>
                  <div style={{ height: 20 }} />
                  <FComponentsLib.FContentText
                    type={'negative'}
                    text={'Freelog_Official'}
                    style={{ maxWidth: 200 }}
                    singleRow
                  />
                </div>
                <FComponentsLib.FContentText
                  type={'negative'}
                  text={'微博'}
                  style={{ maxWidth: 200 }}
                  singleRow
                />
              </Space>
              <Space size={10} direction={'vertical'} align={'center'}>
                <div className={styles.moreItem}>
                  <img src={img_QQChatQR} style={{ width: 140, height: 140 }} alt={''} />
                </div>
                <FComponentsLib.FContentText
                  type={'negative'}
                  text={'官方活动答疑QQ群'}
                  style={{ maxWidth: 200 }}
                  singleRow
                />
              </Space>
              <Space size={10} direction={'vertical'} align={'center'}>
                <div className={styles.moreItem}>
                  <img src={img_weixinQR} style={{ width: 140, height: 140 }} alt={''} />
                </div>
                <FComponentsLib.FContentText
                  type={'negative'}
                  text={'官方活动答疑微信'}
                  style={{ maxWidth: 200 }}
                  singleRow
                />
              </Space>
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: '#FAFBFC' }}>
          <FPropaganda />
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ border: '1px solid #979797', width: 680, opacity: 0.15 }} />
          </div>
          <FPageFooter />
        </div>
      </div>

      <Modal
        open={$ruleShow}
        title={null}
        footer={null}
        // closable={false}
        width={1000}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        bodyStyle={{ height: 'calc(100vh - 200px)', padding: 0 }}
        onCancel={() => {
          set$ruleShow(false);
        }}
      >
        <div className={styles.ruleModalBody}>
          <div className={styles.ruleModalContent}>
            <div style={{ height: 40 }} />
            <div className={styles.h1}>活动规则</div>
            <div className={styles.h2}>1、活动时间</div>
            <div className={styles.h3}>1.1 活动期限</div>
            <div className={styles.content}>
              本活动自
              {activityDetailsPage.startTime?.format('YYYY-MM-DD HH:mm:ss')}
              起，至{activityDetailsPage.endTime?.format('YYYY-MM-DD HH:mm:ss')}
              止。
            </div>
            <div className={styles.h3}>1.2 结果公示</div>
            <div className={styles.content}>
              活动结束后的15个工作日内为活动评选阶段，最终活动结果将于
              {'活动结束后15个工作日'}公布。
            </div>
            <div className={styles.h3}>1.3 参与建议</div>
            <div className={styles.content}>
              为保证您的活动参与体验，请尽量使用PC端访问freelog网页版。
            </div>
            <div className={styles.h2}>2、活动奖项设置</div>
            <div className={styles.h3}>2.1 “优秀创作奖”</div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;一等奖（每赛道1名，共4名），奖励现金¥2000；
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;二等奖（每赛道1名，共4名），奖励现金¥1000；
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;三等奖（每赛道1名，共4名），奖励现金¥500。
            </div>
            <div className={styles.h3}>2.2 “入围奖”</div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;成功发布符合基础标准的任一连载小说、连载漫画、音乐专辑或连载播客合集，即可享受¥100入围奖励。
            </div>
            <div className={styles.h3}>2.3 “反馈之星”</div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;对在Freelog【社区】的
              <a href={'https://forum.freelog.cn/category/3'} target={'_blank'}>
                【吐槽反馈区】
              </a>
              发布“玩转合集”过程中的使用反馈和建议，且有效反馈数量前5的用户，我们将分别奖励现金¥50。
            </div>
            <div className={styles.h3}>2.4 补充说明</div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;“优秀创作奖”和“入围奖”单一获奖，两者不可兼得
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;“反馈之星”奖项可以与上述奖项同时获得
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;活动奖励将在活动公示日后的15个工作日内发放
            </div>
            <div className={styles.h2}>3、活动参与方式</div>
            <div className={styles.content} style={{ paddingLeft: 0 }}>
              内测资格获取：所有参与用户需获得Freelog内测资格。已获得内测资格的用户可以直接参与活动。未获得内测资格的用户需在Freelog平台（
              <a href={'https://www.freelog.cn'} target={'_blank'}>
                www.freelog.cn
              </a>
              ）完成注册，并提交内测资格申请或联系官方工作人员获取邀请码。
            </div>
            <div className={styles.h3}>3.1 “优秀创作奖”参与方式</div>
            <div className={styles.content}>
              用户通过“工作台”-“创建资源”-“发行合集”成功发行原创小说、漫画、音乐或播客合集，即自动获得“优秀创作奖”评选资格。Freelog官方将根据合集的原创性、完整性、创新性、质量、传播性等因素进行综合评估，选出最终获奖作品。
            </div>
            <div className={styles.h3}>3.2 “入围奖”参与方式</div>
            <div className={styles.content}>
              只要成功发布符合基础标准的任一连载小说、连载漫画、音乐专辑或连载播客合集，即可享受¥100入围奖励。
            </div>
            <div className={styles.h3}>3.3 “反馈之星”参与方式：</div>
            <div className={styles.content}>
              用户需在Freelog【社区】的
              <a href={'https://forum.freelog.cn/category/3'} target={'_blank'}>
                【吐槽反馈区】
              </a>
              ，在该模块内发帖，提交您“玩转合集”过程中的使用反馈和建议。Freelog官方将根据反馈的总数、可行性和对产品改进的贡献度进行评审。
            </div>
            <div className={styles.h2}>4、活动参与要求</div>
            <div className={styles.h3}>4.1 资源类型要求</div>
            <div className={styles.content}>
              Freelog平台目前已支持原创小说/文章、漫画、图片、音频(音乐/音效/播客）、视频、游戏/主题/插件开发等类型资源的发布。此外，Freelog已特别优化合集功能，目前支持连载小说/连载漫画/音乐专辑/连载播客等类型的合集资源发布。用户在选定资源类型后，需上传与该类型相匹配的资源文件。如果资源文件与选择的类型不匹配，将无法参与活动评选。
            </div>
            <div className={styles.h3}>4.2 无效资源</div>
            <div className={styles.content}>
              严禁上传空白文件、无实质内容的资源，以及其他任何形式的虚假或无意义资源。一经发现，相关资源将无法参与活动评选。
            </div>
            <div className={styles.h3}>4.3 保持上架</div>
            <div className={styles.content}>
              参与本次活动的资源和展品必须在活动结束之前保持上架状态，否则，可能会影响活动奖励的发放。
            </div>
            <div className={styles.h3}>4.4 活动资源原创性与版权规则</div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;用户发布的资源必须为原创作品，禁止抄袭、搬运、代投、恶意二改（即未经授权对他人作品进行修改，尤其是以损害原作品完整性或原始意图的方式）他人内容等；
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;对于合作创作的资源，参与各方应协商一致，通过一个指定的特定账号进行发布。严禁多人使用各自账号重复发布相同或相似的合作资源；
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;用户需确保对发布的资源拥有完整的著作权或已获得必要的授权，若因未获得授权或侵犯他人版权导致任何法律纠纷，Freelog平台不承担任何法律责任。相关责任由侵权用户自行承担；
            </div>
            <div className={styles.content}>
              ·&nbsp;&nbsp;&nbsp;一经发现用户有违反上述原创性与版权规则的，其相关资源将无法参与活动评选。
            </div>
            <div className={styles.h3}>4.5 平台管理规范</div>
            <div className={styles.content}>
              所有用户须遵守
              <a
                href={
                  'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2 '
                }
                target={'_blank'}
              >
                《Freelog平台管理规范》
              </a>
              ，一经发现用户存在违反平台管理规范的行为，其相关资源将无法参与活动评选。
            </div>
            <div className={styles.h2}>5、活动常见Q&A：</div>
            <div className={styles.h3}>5.1 如何在授权合约流程中使用真实货币交易</div>
            <div className={styles.content}>
              内测期间，Freelog暂不支持真实货币交易，为了便于用户体验资源授权合约交易中的付费相关功能，Freelog提供虚拟币——“羽币”支持。
            </div>
            <div className={styles.content}>
              内测期间，羽币与真实货币无任何联系，Freelog平台不支持以任何形式、任何比例进行羽币与真实货币之间的兑换。
            </div>
            <div className={styles.h3}>5.2 如何领取羽币</div>
            <div className={styles.content}>
              用户可以通过点击【个人中心】—【我的钱包】进入“羽币账户”界面，先点击激活您的羽币账户后，点击下方【立即领取】按钮即可领取100枚内测羽币。
            </div>
            <div className={styles.content}>
              <img src={img_yubi} alt={''} style={{ width: '100%' }} />
            </div>
            <div className={styles.content}>
              更多活动问题答疑详见{' '}
              <a
                href={'https://freelog3.freelog.cn/home_freelog-query_id=62d0d04f456ff0002e329537'}
                target={'_blank'}
              >
                常见问题
              </a>
            </div>
            <div className={styles.h2}>6、违规举报</div>
            <div className={styles.content}>
              活动期间开放举报通道，用户可以通过联系官方工作人员或向Freelog发送邮件（
              service@freelog.com ）对涉嫌违规的行为和用户进行举报。
              举报邮件内容需包含被举报作品名称、作品链接、涉嫌违规原因，否则不予处理；
            </div>
            <div className={styles.h2}>7、平台声明</div>
            <div className={styles.content}>
              活动最终解释权归Freelog所有，如有疑问请联系官方工作人员或发送邮件至官方邮箱
              service@freelog.com。
            </div>
            <div style={{ height: 60 }} />
          </div>
        </div>
      </Modal>

      <Modal
        open={$announceShow}
        // open={true}
        title={null}
        footer={null}
        // closable={false}
        width={1000}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        bodyStyle={{ height: 'calc(100vh - 200px)', padding: 0 }}
        onCancel={() => {
          set$announceShow(false);
        }}
      >
        <div className={styles.announceModalBody}>
          <div style={{ height: 40 }} />
          <div className={styles.h1}>获奖公示</div>
          <div style={{ height: 40 }} />
          <RuleModalBlock
            titleImg={img_xiaoshuo}
            // resourceIDs={[
            //   '66b9d54bf6ea12002fd01418',
            //   '66da7598b1916800309d5bff',
            //   '66cd9589fd260f0030d9eed8',
            // ]}
            resources={[
              {
                id: '675b2c5c0d411d002fc748fb',
                ranking: 3,
              },
              {
                id: '675efce10d411d002fc796c4',
                ranking: 3,
              },
            ]}
          />
          <RuleModalBlock
            titleImg={img_manhua}
            // resourceIDs={[
            //   '66b9d54bf6ea12002fd01418',
            //   '66da7598b1916800309d5bff',
            //   '66cd9589fd260f0030d9eed8',
            // ]}
            resources={[
              {
                id: '67356784446d67002f9922b3',
                ranking: 1,
              },
              {
                id: '671a4d60446d67002f97d074',
                ranking: 2,
              },
            ]}
            backgroundColor={'#fff'}
          />
          {/*<RuleModalBlock*/}
          {/*  titleImg={img_yinyue}*/}
          {/*  resourceIDs={[*/}
          {/*    '66b9d54bf6ea12002fd01418',*/}
          {/*    '66da7598b1916800309d5bff',*/}
          {/*    '66cd9589fd260f0030d9eed8',*/}
          {/*  ]}*/}
          {/*/>*/}
          <RuleModalBlock
            titleImg={img_boke}
            // resourceIDs={[
            //   '66b9d54bf6ea12002fd01418',
            //   '66da7598b1916800309d5bff',
            //   '66cd9589fd260f0030d9eed8',
            // ]}
            resources={[
              {
                id: '67331a1a446d67002f99095b',
                ranking: 1,
              },
              {
                id: '67174329446d67002f9794af',
                ranking: 2,
              },
              {
                id: '673c2fe8446d67002f997940',
                ranking: 3,
              },
            ]}
            backgroundColor={'#fff'}
          />
          <div style={{ backgroundColor: 'rgba(0,0,0,.02)' }}>
            <div style={{ height: 50 }} />
            <div
              style={{
                fontSize: 20,
                color: '#222222',
                lineHeight: '24px',
                textAlign: 'center',
              }}
            >
              入围奖
            </div>
            <div style={{ height: 30 }} />
            <div style={{ padding: '0 100px', display: 'flex', gap: 10 }}>
              <div
                style={{
                  fontSize: 12,
                  color: '#999999',
                  lineHeight: '18px',
                }}
              >
                入围奖获奖名单
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: '#E9A923',
                  lineHeight: '18px',
                }}
              >
                每人100元奖金
              </div>
            </div>
            <div style={{ height: 5 }} />
            <NameList
              names={[
                'Gabi 《生活本该如此》',
                'linglongxinyang 《慎中平华录》',
                'linglongxinyang 《玲珑心阳专辑-蹦蹦跳跳集》',
              ]}
            />
            <div style={{ height: 50 }} />
            <div
              style={{
                fontSize: 20,
                color: '#222222',
                lineHeight: '24px',
                textAlign: 'center',
              }}
            >
              反馈奖
            </div>
            <div style={{ height: 30 }} />
            <div style={{ padding: '0 100px', display: 'flex', gap: 10 }}>
              <div
                style={{
                  fontSize: 12,
                  color: '#999999',
                  lineHeight: '18px',
                }}
              >
                反馈奖获奖名单
              </div>
              <div
                style={{
                  fontSize: 12,
                  color: '#E9A923',
                  lineHeight: '18px',
                }}
              >
                每人50元奖金
              </div>
            </div>
            <div style={{ height: 5 }} />
            <NameList names={['linglongxinyang', 'Gabi', 'yueyueyue']} />
            <div style={{ height: 100 }} />
            <div
              style={{
                fontSize: 12,
                color: '#999',
                lineHeight: '18px',
                textAlign: 'center',
              }}
            >
              <div>
                奖励将在结果公示期结束后，即在官方公布最终获奖名单后的15个工作日内，发放至获奖用户的Freelog账号名下
              </div>
              <div>由于系统问题，部分反馈奖获奖用户在社区发布的反馈目前暂时无法显示。</div>
            </div>
            <div style={{ height: 100 }} />
          </div>
        </div>
      </Modal>
    </>
  );
}

export default connect(({ activityDetailsPage }: ConnectState) => ({
  activityDetailsPage,
}))(Contest202409);

interface RuleModalBlockProps {
  titleImg: string;
  resources: {
    ranking: 1 | 2 | 3;
    id: string;
  }[];
  backgroundColor?: string;
}

function RuleModalBlock({
  titleImg,
  resources,
  backgroundColor = 'rgba(0, 0, 0, .02)',
}: RuleModalBlockProps) {
  const [$card, set$card, get$card] = FUtil.Hook.useGetState<
    {
      resourceID: string;
      resourceName: string;
      resourceTitle: string;
      resourceCover: string;
      userAvatar: string;
      userName: string;
      href: string;
      ranking: 1 | 2 | 3;
    }[]
  >([]);

  AHooks.useMount(async () => {
    const {
      data,
    }: {
      data: any[];
    } = await FServiceAPI.Resource.batchInfo({
      resourceIds: resources
        .map((r) => {
          return r.id;
        })
        .join(','),
    });

    set$card(
      resources.map((r, index) => {
        const resource = data.find((d) => {
          return d.resourceId === r.id;
        });
        return {
          resourceID: r.id,
          resourceName: resource?.resourceName || '',
          resourceTitle: resource?.resourceTitle || '',
          resourceCover: resource?.coverImages[0] || '',
          userAvatar: FUtil.Domain.IMAGE_ORIGIN + `/avatar/${resource?.userId || ''}`,
          userName: resource?.username || '',
          href:
            FUtil.Format.completeUrlByDomain('console') +
            FUtil.LinkTo.collectionDetails({ collectionID: r.id }),
          ranking: r.ranking,
        };
      }),
    );
  });

  return (
    <div className={styles.ruleModalBlock} style={{ backgroundColor: backgroundColor }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <img src={titleImg} style={{ width: 108, height: 24 }} alt={''} />
      </div>
      <div style={{ height: 30 }} />
      <div className={styles.cards}>
        {$card.map((c, ci) => {
          return (
            <div className={styles.card} key={c.resourceID}>
              {c.ranking === 1 && <div className={styles.cardTitle}>一等奖 ¥2000</div>}
              {c.ranking === 2 && <div className={styles.cardTitle}>二等奖 ¥1000</div>}
              {c.ranking === 3 && <div className={styles.cardTitle}>三等奖 ¥500</div>}

              <div style={{ height: 20 }} />
              <FCoverImage src={c.resourceCover} width={240} className={styles.cover} />
              <div style={{ height: 10 }} />
              <div
                className={styles.resourceTitle}
                onClick={() => {
                  self.open(c.href);
                }}
              >
                {c.resourceTitle || c.resourceName.split('/')[1]}
              </div>
              <div style={{ height: 10 }} />
              <div className={styles.userInfo}>
                <img src={c.userAvatar} alt={''} />
                <FComponentsLib.FContentText
                  type={'additional2'}
                  style={{ color: '#666', maxWidth: 200 }}
                  singleRow
                  text={c.userName}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

interface NameListProps {
  names: string[];
}

function NameList({ names }: NameListProps) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '0 100px',
      }}
    >
      {names.map((n, ni) => {
        return (
          <React.Fragment key={ni}>
            {ni % 3 === 0 && (
              <div
                style={{
                  borderTop: '1px solid rgba(0,0,0,.1)',
                  flexBasis: '100%',
                }}
              />
            )}
            <div
              style={{
                flexBasis: '33.33%',
                height: 50,
                alignItems: 'center',
                display: 'flex',
              }}
            >
              {n}
            </div>
          </React.Fragment>
        );
      })}
      <div style={{ borderTop: '1px solid rgba(0,0,0,.1)', flexBasis: '100%' }} />
    </div>
  );
}
